import { render, staticRenderFns } from "./approved-trainings.vue?vue&type=template&id=88e236f4&"
import script from "./approved-trainings.vue?vue&type=script&lang=js&"
export * from "./approved-trainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports